import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import dayjs from "dayjs";
import AdminNav from "../../components/adminNav/AdminNav";
import { getEmployee } from "../../models/employees";
import "./adminEmails.css";
import "./adminCancelled.css";

const PAGE_SIZE = 20;

export const AdminCancelled = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [search, setSearch] = useState("");

  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));

  const fetchCancelled = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      let url = `${process.env.REACT_APP_API_URL_FETCH_CANCELLED}?page=${page}&limit=${PAGE_SIZE}`;
      if (search) {
        url += `&q=${encodeURIComponent(search)}`;
      }
      const res = await axios.get(url);
      setRows(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch (err) {
      console.error("Failed to fetch cancelled reservations:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [page, search]);

  useEffect(() => {
    fetchCancelled();
  }, [fetchCancelled]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  return (
    <div className="admin">
      <AdminNav />
      <div className="emailsTable cancelledTable">
        <h2 style={{ margin: "0 0 16px", color: "#333" }}>
          Zrušené rezervace ({total})
        </h2>

        <div className="emailFilterRow">
          <input
            type="text"
            value={search}
            onChange={handleSearchChange}
            placeholder="Hledat podle jména nebo telefonu…"
            className="emailFilterInput"
          />
          {search && (
            <button
              className="emailFilterClear"
              onClick={() => { setSearch(""); setPage(1); }}
            >
              ✕
            </button>
          )}
        </div>

        {loading ? (
          <p>Načítání…</p>
        ) : error ? (
          <p>Nepodařilo se načíst zrušené rezervace.</p>
        ) : rows.length === 0 ? (
          <p>Žádné zrušené rezervace.</p>
        ) : (
          <>
            <table>
              <thead>
                <tr>
                  <th>Zrušeno</th>
                  <th>Datum</th>
                  <th>Začátek</th>
                  <th>Klient</th>
                  <th>Telefon</th>
                  <th>Email</th>
                  <th>Barber</th>
                  <th>Služba</th>
                  <th>Extra služby</th>
                  <th>Cena</th>
                  <th>Stav</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => {
                  const employee = getEmployee(parseInt(row.zamestnanecId, 10));
                  return (
                    <tr
                      key={row.id}
                      className={
                        index % 2 === 0 ? "table-row-even" : "table-row-odd"
                      }
                    >
                      <td>{dayjs(row.zruseno_at).format("DD.MM.YYYY HH:mm")}</td>
                      <td>{dayjs(row.datum).format("DD.MM.YYYY")}</td>
                      <td>{dayjs(row.zacatek_cas, "HH:mm:ss").format("HH:mm")}</td>
                      <td>{row.klient_jmeno}</td>
                      <td>{row.klient_telefon}</td>
                      <td>{row.klient_email}</td>
                      <td>{employee ? employee.name : "—"}</td>
                      <td className="subjectCell">{row.klient_sluzba}</td>
                      <td className="subjectCell">
                        {row.klient_sluzby_dodatecne || "—"}
                      </td>
                      <td>{row.klient_cena} Kč</td>
                      <td>
                        {parseInt(row.pozdni_zruseni, 10) === 1 ? (
                          <span className="statusBadge statusBadge--failed">
                            Pozdní
                          </span>
                        ) : (
                          <span className="statusBadge statusBadge--success">
                            Včas
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="paginationControls">
              <button onClick={() => setPage(1)} disabled={page <= 1}>
                {"«"}
              </button>
              <button
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page <= 1}
              >
                {"‹"}
              </button>
              <span className="paginationInfo">
                Strana {page} z {pageCount}
              </span>
              <button
                onClick={() => setPage((p) => Math.min(pageCount, p + 1))}
                disabled={page >= pageCount}
              >
                {"›"}
              </button>
              <button
                onClick={() => setPage(pageCount)}
                disabled={page >= pageCount}
              >
                {"»"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
